import EmptyState from './EmptyState';

/**
 * Simple vertical timeline. items: [{ id, date, title, subtitle, body }]
 */
export default function Timeline({ items, emptyMessage }) {
  if (!items?.length) return <EmptyState message={emptyMessage || 'No activity yet.'} />;
  return (
    <div>
      {items.map((it) => (
        <div key={it.id} style={{ display: 'flex', gap: 12, paddingBottom: 14 }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--hrms-primary)' }} />
            <span style={{ flex: 1, width: 2, background: 'var(--hrms-border)' }} />
          </div>
          <div style={{ flex: 1 }}>
            {it.date && <div className="hrms-muted" style={{ fontSize: '0.78rem' }}>{it.date}</div>}
            {it.title && <div style={{ fontWeight: 600 }}>{it.title}</div>}
            {it.subtitle && <div className="hrms-muted" style={{ fontSize: '0.82rem' }}>{it.subtitle}</div>}
            {it.body && <div style={{ fontSize: '0.88rem', marginTop: 2 }}>{it.body}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
